import React from 'react'
import classnames from 'classnames'
import Select from 'react-select'
import defaultSelectTheme from './styles/defaultSelectTheme'

const themeProps = {
  default: defaultSelectTheme,
  "inline-sm": Object.assign({}, defaultSelectTheme, {
    container: (provided, state) => ({ ...provided, "width": "90px" }),
    dropdownIndicator: (provided, state) => {
      return {
        ...provided,
        "color": "black",
        "visibility": state.isDisabled ? 'hidden' : 'visible'
      }
    },
    singleValue: (provided, state) => {
      return {
        ...provided,
        "max-width": "100%"
      }
    }
  })
}

const InlineSelect = ({
  type, id, error, value, onChange,
  className, theme, ...props
}) => {

  const prefix = 'react-select';
  const classes = classnames(
    prefix, `${prefix}--${theme}`,
    {
      'react-select--invalid': !!error,
    },
    className
  );

  return (
    <Select
      id={id}
      value={value}
      onChange={onChange}
      className={classes}
      classNamePrefix={prefix}
      styles={themeProps[theme]}
      {...props}
    />
  );
};

InlineSelect.defaultProps = {
  theme: "default"
}

export default InlineSelect
